/* eslint-disable @typescript-eslint/no-unused-vars */
import React,{useState} from 'react';
import {checkInteractions,SEVERITY_COLORS} from '../../utils/drugInteractions';

interface Props {
  drugs: string[];
  allergies?: string[];
  newDrug?: string;
  compact?: boolean;
}

export default function DrugInteractionAlert({drugs,allergies=[],newDrug,compact=false}:Props){
  const [expanded,setExpanded]=useState(true);
  const allDrugs=newDrug?[newDrug,...drugs]:drugs;
  const interactions=checkInteractions(allDrugs);

  const allergyAlerts:string[]=[];
  const checkDrug=(newDrug||'').toUpperCase();
  if(checkDrug&&allergies.length>0){
    for(const allergy of allergies){
      const al=allergy.toUpperCase();
      if(checkDrug.includes(al.split(' ')[0])||al.includes(checkDrug.split(' ')[0]))
        allergyAlerts.push(`Patient is allergic to ${allergy}`);
      if((al.includes('PENICILLIN')||al.includes('AMOXICILLIN'))&&(checkDrug.includes('CEF')||checkDrug.includes('CEPHALOSPORIN')))
        allergyAlerts.push(`Possible cross-reactivity: penicillin allergy → cephalosporins (3-7% risk)`);
      if(al.includes('SULPHA')&&(checkDrug.includes('SULPHA')||checkDrug.includes('COTRIMOXAZOLE')))
        allergyAlerts.push(`Patient has sulpha allergy — cross-reaction risk`);
      if(al.includes('ASPIRIN')&&(checkDrug.includes('IBUPROFEN')||checkDrug.includes('DICLOFENAC')||checkDrug.includes('NAPROXEN')))
        allergyAlerts.push(`Aspirin-allergic patient — NSAID cross-sensitivity possible`);
    }
  }

  if(interactions.length===0&&allergyAlerts.length===0) return null;
  const majorCount=interactions.filter(i=>i.severity==='MAJOR').length;
  const moderateCount=interactions.filter(i=>i.severity==='MODERATE').length;

  if(compact) return(
    <span className={`text-xs px-2 py-0.5 rounded-full border font-semibold ${majorCount>0?'bg-red-50 border-red-400 text-red-700':moderateCount>0?'bg-amber-50 border-amber-400 text-amber-700':'bg-yellow-50 border-yellow-400 text-yellow-700'}`}>
      {majorCount>0?'🚨':moderateCount>0?'⚠️':'💡'} {interactions.length+allergyAlerts.length} alert{interactions.length+allergyAlerts.length>1?'s':''}
    </span>
  );

  return(
    <div className="space-y-2 mt-2">
      {allergyAlerts.map((a,i)=>(
        <div key={i} className="bg-red-50 border-2 border-red-500 rounded-xl p-3 flex gap-2">
          <span className="text-xl flex-shrink-0">🚨</span>
          <div><p className="font-bold text-red-800 text-sm">ALLERGY ALERT</p><p className="text-xs text-red-700">{a}</p><p className="text-xs text-red-600 mt-1 font-semibold">Verify with prescriber before dispensing.</p></div>
        </div>
      ))}
      {interactions.length>0&&(
        <div className={`border-2 rounded-xl overflow-hidden ${majorCount>0?'border-red-400':'border-amber-400'}`}>
          <button type="button" onClick={()=>setExpanded(!expanded)} className={`w-full flex items-center justify-between p-3 text-left ${majorCount>0?'bg-red-50':'bg-amber-50'}`}>
            <div className="flex items-center gap-2">
              <span className="text-lg">{majorCount>0?'🚨':'⚠️'}</span>
              <div>
                <p className={`font-bold text-sm ${majorCount>0?'text-red-800':'text-amber-800'}`}>{interactions.length} Drug Interaction{interactions.length>1?'s':''}</p>
                <p className="text-xs text-slate-500">{majorCount>0&&<span className="text-red-600 font-semibold">{majorCount} MAJOR </span>}{moderateCount>0&&<span className="text-amber-600 font-semibold">{moderateCount} MODERATE</span>}</p>
              </div>
            </div>
            <span className="text-slate-400 text-sm">{expanded?'▲':'▼'}</span>
          </button>
          {expanded&&<div className="divide-y bg-white">
            {interactions.map((ix,i)=>{
              const col=SEVERITY_COLORS[ix.severity];
              return(<div key={i} className={`p-3 ${col.bg}`}>
                <div className="flex items-center gap-2 mb-1"><span className={`text-xs font-bold px-2 py-0.5 rounded-full ${col.badge}`}>{col.icon} {ix.severity}</span><span className={`font-semibold text-sm ${col.text}`}>{ix.drug1} ↔ {ix.drug2}</span></div>
                <div className="pl-2 text-xs space-y-0.5"><p><b>Effect:</b> {ix.effect}</p><p><b>Mechanism:</b> {ix.mechanism}</p><p className={`font-semibold ${col.text}`}>⚡ {ix.recommendation}</p></div>
              </div>);
            })}
          </div>}
        </div>
      )}
    </div>
  );
}
